import React, { useState, useContext, useEffect } from 'react';
import axiosConfig from '../../../../../../utils/axiosConfig';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-material-ui';
import {
    Button, Dialog, DialogActions,
    DialogContent, DialogTitle,
    Grid, Slide
} from '@material-ui/core';

import { StateContext, DispatchContext } from '../../../../../../context/Provider';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const CommentModalForm = (props) => {

    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const { globalDispatch } = appDispatch;

    const [comment, setComment] = useState({
        id: '',
        description: ''
    });

    async function updateComment(values, resetForm) {
        const res = await axiosConfig.post(`/comments/${props.commentID}`, {
            _method: 'PATCH',
            description: values.description
        });

        if (res.data.status_code === 'ok') {
            globalDispatch({type: 'setSnackbarMsg', value: 'Comment updated successfully.'});
            globalDispatch({type: 'setIsOpenSnackbar', value: true});

            props.fetchAnnouncements();
            props.handleClose();
        } else {
            console.log(res);
        }

        globalDispatch({type: 'setIsLoading', value: false});
        setTimeout(() => {
            globalDispatch({type: 'setIsOpenSnackbar', value: false});
        }, 1200);
    }

    useEffect(() => {
        if (props.commentID) {
            setComment({
                id: props.commentID,
                description: props.description
            });
        }
    }, [props.commentID]);

    return (
        <Dialog 
            open={props.open} 
            onClose={props.handleClose} 
            aria-labelledby="form-dialog-title"
            fullWidth={true} 
            maxWidth={'sm'}
            TransitionComponent={Transition}
            disableBackdropClick 
        >
            <Formik
                initialValues={comment}
                validate={(values) => {
                    const errors = {};

                    if (!values.description) {
                        errors.description = 'This field is required';
                    }

                    return errors;
                }}
                onSubmit={(values, {setSubmitting, resetForm}) => {

                    setSubmitting(false);
                    globalDispatch({type: 'setIsLoading', value: true});

                    // setTimeout(() => {
                    //     setSubmitting(false);
                    //     alert(JSON.stringify(values, null, 2));
                    //     resetForm();
                    //     globalDispatch({type: 'setIsLoading', value: false});
                    // }, 500);

                    updateComment(values, resetForm);
                }}
            >
                {({submitForm, isSubmitting, touched, errors}) => (
                    <Form>
                        <DialogTitle id="form-dialog-title">
                            {props.dialogTitle}
                        </DialogTitle>
                        <DialogContent>
                            <Grid container alignItems="flex-start" spacing={2}>

                                <Grid item xs={12}>
                                    <Field
                                        component={TextField}
                                        label="Description (required)"
                                        name="description"
                                        fullWidth
                                        variant="outlined"
                                        multiline
                                        rows={4}
                                        // rowsMax={4}
                                    />
                                </Grid>

                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button 
                                onClick={props.handleClose} 
                                disabled={isSubmitting} 
                                color="secondary"
                            >
                                Cancel
                            </Button>
                            <Button 
                                disabled={isSubmitting} 
                                onClick={submitForm} color="primary"
                            >
                                Submit
                            </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}

export default CommentModalForm;